import { FilterTypes } from 'components/drawer/panels/genericContent/types';
import {  } from './../drawer/panels/genericContent/types';
import { SearchableTypeEnum } from "graphql/types/globalTypes";
import { emptyFilterStringExists, removeDuplicates } from "utils/helpers";
import { QueryVariables } from './context';

interface SpecialTermsReturn {
  terms: string[],
  tags: string[],
}


interface CustomFilterArgs {
  values: any,
  queryVariables: QueryVariables,
}

export type SaveSearchTypes = FilterTypes['searchConfigType']
/**
 * Convert terms to tags.
 * - If prefix matches "id"
 * @param {string} terms A string of search terms.
 */
export function tagifySpecialTerms(terms: string): SpecialTermsReturn {
  const termsSeparatedBySpaces = terms.split(" ");
  const termsTotal = termsSeparatedBySpaces.length;
  const tags = [];
  const termsRemoveableIndex = [];

  // No spaces between at least the first item, return terms unchanged.
  if (termsSeparatedBySpaces.length <= 1) return {
    terms: [terms],
    tags,
  };

  // Check each term for a special tag prefix
  termsSeparatedBySpaces.map((term, index) => {
    const splits = term.split(":");
    const position = index + 1;

    if (splits.length > 1) {
      // Once split on ":"; and prefixed with "id"; and less than total which indicates it's followed by a space or term;
      // Then push the special term as a tag.
      if (splits[0] === "id" && Number(splits[1]) && position < termsTotal) {
        termsRemoveableIndex.push(index); // remove from terms
        tags.push(term); // create tag from term
      }
    }

    return term;
  });

  const termWithoutTags = termsSeparatedBySpaces.filter((_term, index) => !termsRemoveableIndex.includes(index));

  return {
    terms: termWithoutTags,
    tags,
  };
}

/**
 * Convert any special term into a filterString.
 * @param {string[]} terms An array of terms to convert; split on the colon per term
 */
export function makeFilterString(terms: string[]): string[] {
  return terms.map((term) => {
    const splits = term.split(':');
    if (!splits[1]) return null;

    return `${splits[0]} = ${splits[1]}`;
  }).filter((term) => term);
}

/**
 * Apply form values to queryVariables to be applied to filtering the table.
 * @param values The form values.
 * @param queryVariables The query variables to be mutated.
 */
export function filterArticlesTable({ values, queryVariables }: CustomFilterArgs): QueryVariables {
  const queryVariablesCopy = {
    ...queryVariables,
  };

  // filter downloadedAt from filterStrings and set in filterString parameter
  if (values?.filterStrings?.some(v => v.includes('downloadedAt'))) {
    const filterStrings = values.filterStrings.filter(v => !v.includes('downloadedAt'));
    const filterString = values.filterStrings.filter(v => v.includes('downloadedAt'));
    queryVariablesCopy['filterStrings'] = [...filterStrings];
    queryVariablesCopy['filterString'] = (emptyFilterStringExists(filterString)) ? [] : [...filterString];
    return queryVariablesCopy;
  }
  // filter startAt and endAt from filterStrings and set in filterString parameter
  if (values?.filterStrings?.some(v => v.includes('startAt') && v.includes('endAt'))) {
    const startAtIndex = values.filterStrings.indexOf('startAt');
    const endAt = values.filterStrings.splice(startAtIndex, 1);
    const filterStrings = endAt.filter(v => !v.includes('endAt'));
    const startAt = values.filterStrings.filter(v => v.includes('startAt'));
    queryVariablesCopy['startAt'] = startAt[0].replace('startAt > ', '');
    queryVariablesCopy['endAt'] = endAt[0].replace('endAt < ', '');
    queryVariablesCopy['filterStrings'] = [...filterStrings];
    return queryVariablesCopy;
  }

  let copyFromQueryVariablesCopy = false
  if (values?.filterStrings?.some(v => v.includes('taxonomy.id')) && queryVariablesCopy.itemTypes[0] == SearchableTypeEnum.ARTICLE) {
    const filterStrings = values?.filterStrings?.filter(v => !v.includes('taxonomy.id')) || [];
    const filterString = values?.filterStrings?.filter(v => v.includes('taxonomy.id')) || [];
    const taxonomyIds = filterString.map((tax) => {
      const splitTaxo = tax.split(' = ');
      return splitTaxo[1];
    });
    // Create separate conditions for each taxonomy ID for AND logic
    const fS = taxonomyIds.map(id => `taxonomy.id = ${id}`);
    const finalFilterString = [...filterStrings, ...fS];
    queryVariablesCopy['filterStrings'] = [...finalFilterString];
    copyFromQueryVariablesCopy = true;
  } else if (queryVariablesCopy?.filterStrings?.some(v => v.includes('taxonomy.id')) && queryVariablesCopy.itemTypes[0] == SearchableTypeEnum.ARTICLE) {
    // Keep existing taxonomy.id filters instead of removing them
    const nonTaxonomyFilters = queryVariablesCopy.filterStrings?.filter(v => !v.includes("taxonomy.id")) || [];
    const taxonomyFilters = queryVariablesCopy.filterStrings?.filter(v => v.includes("taxonomy.id")) || [];
    queryVariablesCopy.filterStrings = [...nonTaxonomyFilters, ...taxonomyFilters];
  }

  let isEnteredinIdCond = false;
  // This one is merging all new and old filters with duplicate fields with diffrent values
  if (queryVariablesCopy.filterStrings?.some(v => v.includes('id'))) {
    const queryVariablesfilterStrings = queryVariablesCopy.filterStrings?.filter(v => !(/^(.*)\.id\s+=\s+(?!\()(.*)$/.test(v))) || [];
    const finalFilterString = [...values.filterStrings, ...queryVariablesfilterStrings];
    queryVariablesCopy['filterStrings'] = finalFilterString;
    isEnteredinIdCond = true;
    copyFromQueryVariablesCopy = true;
  }

  // Remove previous all keyword.id filterstring and only keep latest one
  // Only keyword.id = () one occurance
  // OR if user removed all keywords then remove it from filterstring as well
  if (queryVariablesCopy.itemTypes[0] == SearchableTypeEnum.ARTICLE && isEnteredinIdCond) {
    const newValueKeywordFilter = values?.filterStrings?.filter(v => v.includes('keyword.id')) || [];
    const newValueTaxonomyFilter = queryVariablesCopy['filterStrings']?.filter(v => v.includes('taxonomy.id')) || [];
    const mainSource = queryVariablesCopy['filterStrings']?.filter(v => !(v.includes('taxonomy.id') || v.includes('keyword.id'))) || [];
    const finalFilterString = [...mainSource, ...newValueKeywordFilter, ...newValueTaxonomyFilter];
    queryVariablesCopy['filterStrings'] = [...finalFilterString];
    copyFromQueryVariablesCopy = true;
  }

  // This needs to be set before pushing on more filterStrings
  queryVariablesCopy.filterStrings = removeDuplicates(copyFromQueryVariablesCopy ? [...queryVariablesCopy.filterStrings] : [...values.filterStrings]);

  console.log('6', queryVariablesCopy?.filterStrings);

  return queryVariablesCopy;
}

/**
 * Extract values compatible to set default fields on custom field filter component
 * @param filterStrings
 * @returns
 */
export function getDefaultValueOfCustomField(filterStrings: string[]) {
  const customFields = filterStrings.filter((val) => val.includes("customField."));

  if (!customFields.length) return '';

  return customFields?.map((val) => val?.replace('customField.', ''));
}

/**
 * Extract active field default value
 * @param filterStrings
 * @returns
 */
export function getDefaultValueActive(filterStrings: string[]) {
  const result = filterStrings.find((val) => val.includes("active"))?.replace("active is ", "");

  return result == 'false' ? 'unpublished' : (result == 'true' ? true : false)
}

// It will generate prefix(default) for new search name
// Ex: Article 29 April
export function getSearchPrefix(type: FilterTypes['searchConfigType']) {
  const today = new Date();
  const day = today.getDate();
  const monthName = today.toLocaleString("default", { month: "long" });

  return `${type.charAt(0).toUpperCase()}${type.slice(1)} ${day} ${monthName
    .charAt(0)
    .toUpperCase()}${monthName.slice(1)}`;
}

// Determine if current module covers Saved search functionality or not
export function isSaveSearchEnabledFor(type: SaveSearchTypes = undefined) {

  if (type) {
    return ['articles'].includes(type);
  }

  return ['editorial/articles', '/editorial/articles'].includes(window.location.pathname);
}